//import env variable 
//console.log('API URL:', process.env.VUE_APP_API_URL);
//const apiUrl = process.env.VUE_APP_API_URL;
//import axios from 'axios';


export default{
  namespaced: true,
  state: {
    user: {
      isLogged: false,
      name: null,
      email: null,
      status: null,
      id: null,
      type: null,
    },
    selectedUser: null,
  },
  getters: {
    isUserEmail: (state) => {
      return state.user.email;
    }
  },
  mutations: {
    loginUser(state, payload) {
      state.user.isLogged = true;
      state.user.token = payload.jwt;
      state.user.name = payload.name;
      state.user.email = payload.email;
      state.user.status = payload.status;
      state.user.id = payload.id;
      state.user.type = payload.type;
      //local
      localStorage.lbToken = payload.jwt;
      localStorage.lbEmail = payload.email;
    },
    logoutUser(state) {
      state.user.isLogged = false;
      state.user.token = null;
      state.user.name = null;
      state.user.email = null;
      state.user.status = null;
      state.user.id = null;
      state.user.type = null;
      //local
      localStorage.removeItem("lbToken");
      localStorage.removeItem("lbEmail");
    },
    validateUser(state, payload) {
      state.user.isLogged = true;
      state.user.token = localStorage.lbToken;
      state.user.name = payload.name;
      state.user.email = payload.email;
      state.user.status = payload.status;
      state.user.id = payload.id;
      state.user.type = payload.type
    },
    setStatus(state, payload) {
      localStorage.removeItem("lbToken");
      localStorage.lbToken = payload.jwt;
      state.user.token = payload.jwt
      state.user.status = payload.status;
    },
    clearUserData(state) {
      state.user.isLogged = false;
      state.user.token = null;
      state.user.name = null;
      state.user.email = null;
      state.user.status = null;
      state.user.id = null;
      state.user.type = null;
    },
    setSelectedUser(state, user) {
      state.selectedUser = user;
    },
    clearSelectedUser(state) {
      state.selectedUser = null;
    },
  },
  actions: {
    loginUser({commit}, payload) {
      commit("loginUser", payload);
    },
    logoutUser({commit}) {
      commit("logoutUser");
      //commit('layouts/dropAllData', null, { root: true });
    },
  },
  modules: {
  }
}
